<div class="template1">
  <div id="header" class="global-banner" style="z-index: 1000;width: 100%; border-radius: 0;margin: 0;position: fixed;" #csheader>
    <app-header></app-header>
  </div>
  <section id="body container-fluid">
    <div class="">
      <div class="csp-body-contennt col-sm-12 d-flex justify-content-between">
        <!-- <div id="sideNav">
            <app-side-menu-bar (openMenuEmit)="sideMenuEmit($event)" *ngIf="permissionsOnLoad"></app-side-menu-bar>
        </div> csheader.offsetHeight + csfooter.offsetHeight -->
        <div id="admin-content" [style.min-height.px]="totalHeight - (csheader.offsetHeight + csfooter.offsetHeight)">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </section>
  <div class="col-xs-12 col-md-12 col-sm-12" id="footer" [style.height.px]="footerHeight" style="overflow:hidden;padding:0px;" #csfooter>
    <app-footer [placeHolderId]="'footer'" [customerType]="'flpi'"></app-footer>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/templates/template1/views/app-layout.component.html